// extracted by mini-css-extract-plugin
export default {"closeBtn":"ModalCloseButton_closeBtn__hyM3j","light":"ModalCloseButton_light__+knmt","dark":"ModalCloseButton_dark__m+kyS"};